<div class="form">
  <!-- <div class="dx-fieldset">
    <div class="dx-field">
      <div class="dx-field-label sia-conf-content" style="width: 70%">
        Ignora i parametri in sessione se gestiti manualmente attraverso dei
        filtri
      </div>
      <div class="dx-field-value" style="width: 30%">
        <dx-switch [(value)]="gridConf.ignoreRouterParams"></dx-switch>
      </div>
    </div>
  </div> -->
  <div id="gridConfigValidationDiv" class="grid-container">
    <!--Testata configurazione colonne-->
    <dx-data-grid
      id="gridConfigSpParams"
      [dataSource]="gridConf.spParameters"
      [showBorders]="true"
      [rowAlternationEnabled]="true"
      [hoverStateEnabled]="true"
      [showColumnLines]="true"
      [showRowLines]="true"
      (onRowUpdated)="onConfigFiltersRowUpdating($event)"
    >
      <dxi-column
        dataField="field"
        [caption]="'Nome Campo' | siaTranslate"
        [width]="150"
      >
      </dxi-column>

      <dxi-column dataField="pattern" [caption]="'Pattern' | siaTranslate">
        <dxo-lookup
          [dataSource]="gridConfPatternsTypes"
          displayExpr="name"
          valueExpr="id"
        >
        </dxo-lookup>
      </dxi-column>

      <dxi-column dataField="staticValue" [caption]="'Valore' | siaTranslate">
      </dxi-column>

      <dxo-editing
        mode="row"
        [allowUpdating]="true"
        [allowDeleting]="true"
        [allowAdding]="true"
        [selectTextOnEditStart]="selectTextOnEditStart"
        [startEditAction]="startEditAction"
      >
      </dxo-editing>

      <dxo-selection mode="single"></dxo-selection>
      <dxo-remote-operations [sorting]="true" [paging]="true">
      </dxo-remote-operations>
      <dxo-sorting mode="multiple"></dxo-sorting>
      <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
      <dxo-load-panel [enabled]="false"></dxo-load-panel>
      <dxo-header-filter [visible]="false"></dxo-header-filter>
      <dxo-filter-row [visible]="false"></dxo-filter-row>
      <dxo-search-panel [visible]="false"></dxo-search-panel>
      <dxo-group-panel [visible]="false"></dxo-group-panel>
      <dxo-grouping #expand [autoExpandAll]="false"></dxo-grouping>
    </dx-data-grid>
  </div>
</div>
